export default __webpack_public_path__ + "static/media/q9_step2_7.8576157f.png";